<template>
  <div>
    <div class="text-h6 text-center mt-2 mb-2">場次資訊</div>
    <div>
      <v-text-field
        label="日期"
        :value="section.日期"
        dense
        outlined
        disabled
      ></v-text-field>
    </div>
    <div>
      <v-text-field
        label="地點"
        :value="section.地點"
        dense
        outlined
        disabled
      ></v-text-field>
    </div>
    <div class="text-center text-h6">掃描民眾 QR code</div>
    <v-btn class="mt-1" x-large block color="success" dark @click="openScan">
      <v-icon large color="white">mdi-camera</v-icon>
    </v-btn>
    <div class="text-center text-h6 mt-12">輸入報到號碼</div>
    <v-text-field
      label="報到號碼"
      v-model="報到號碼"
      dense
      outlined
      hide-details
      clearable
      type="number"
    ></v-text-field>
    <v-btn
      class="mt-3 text-h6"
      x-large
      block
      color="success"
      dark
      @click="search"
    >
      查詢
    </v-btn>
  </div>
</template>

<script>
import { mapFields } from "vuex-map-fields";
import station from "@/mixins/station";
export default {
  mixins: [station],
  data: () => ({
    報到號碼: "",
  }),
  computed: {
    ...mapFields([
      "station.person",
      "station.section",
      "station.type",
      "station.scan",
    ]),
  },
  created() {
    this.person = {};
  },
  methods: {
    openScan() {
      this.scan.dialog = true;
    },
    async search() {
      let params = {
        日期: this.section.日期,
        地點: this.section.地點,
        報到號碼: this.報到號碼,
      };
      this.person = (await this.axios.get(`/person`, { params })).data;
      this.goStation();
    },
  },
};
</script>
<style lang="scss" scoped>
.loading {
  height: 100%;
  width: 100%;
}
</style>